import { create } from 'zustand';

const useActiveLayersStore = create(
    (set, get) => ({

        spatialResArray: [],
        temporalResArray: [],
        selectedLayers: [],

        getSelectedLayerInfo: (index) => {
            const state = get();
            return {
                spaceRes: state.spatialResArray[index],
                temporalRes: state.temporalResArray[index]
            }
        },

        moveSelectedLayerUp: (index) => set((state) => {

            const reorderedLayers = [...state.selectedLayers];
            const reorderedSpatialRes = [...state.spatialResArray];
            const reorderedTemporalRes = [...state.temporalResArray];

            [reorderedLayers[index - 1], reorderedLayers[index]] = [reorderedLayers[index], reorderedLayers[index - 1]];
            [reorderedSpatialRes[index - 1], reorderedSpatialRes[index]] = [reorderedSpatialRes[index], reorderedSpatialRes[index - 1]];
            [reorderedTemporalRes[index - 1], reorderedTemporalRes[index]] = [reorderedTemporalRes[index], reorderedTemporalRes[index - 1]];

            return {
                spatialResArray: [...reorderedSpatialRes],
                temporalResArray: [...reorderedTemporalRes],
                selectedLayers: [...reorderedLayers]
            };

        }),

        moveSelectedLayerDown: (index) => set((state) => {
            const reorderedLayers = [...state.selectedLayers];
            const reorderedSpatialRes = [...state.spatialResArray];
            const reorderedTemporalRes = [...state.temporalResArray];

            [reorderedLayers[index], reorderedLayers[index + 1]] = [reorderedLayers[index + 1], reorderedLayers[index]];
            [reorderedSpatialRes[index], reorderedSpatialRes[index + 1]] = [reorderedSpatialRes[index + 1], reorderedSpatialRes[index]];
            [reorderedTemporalRes[index], reorderedTemporalRes[index + 1]] = [reorderedTemporalRes[index + 1], reorderedTemporalRes[index]];

            return {
                spatialResArray: [...reorderedSpatialRes],
                temporalResArray: [...reorderedTemporalRes],
                selectedLayers: [...reorderedLayers]
            };
        }),
        
        addSelectedLayer: (spatialRes, temporalRes, selectedLayer) =>  set((state) => ({
            spatialResArray: [...state.spatialResArray, spatialRes],
            temporalResArray: [...state.temporalResArray, temporalRes],
            selectedLayers: [...state.selectedLayers, selectedLayer]
        })),

        addSelectedLayers: (updatedSpatialArray, updatedTemporalArray, updatedSelectedLayers) => set((state) => ({
            spatialResArray: [...state.spatialResArray, ...updatedSpatialArray],
            temporalResArray: [...state.temporalResArray, ...updatedTemporalArray],
            selectedLayers: [...state.selectedLayers, ...updatedSelectedLayers]
        })),

        updateSelectedLayers: (updatedSpatialArray, updatedTemporalArray, updatedSelectedLayers) => set((state) => ({
            spatialResArray: [...updatedSpatialArray],
            temporalResArray: [...updatedTemporalArray],
            selectedLayers: [...updatedSelectedLayers]
        })),

        updateSpatialResArray: (layer, newSpatialRes) => set((state) => {
            const index = state.selectedLayers.indexOf(layer);
            if (index == -1) return {};

            const updatedArray = state.spatialResArray.map((spatialRes, i) =>
                i === index ? newSpatialRes : spatialRes
            );
            return { spatialResArray: updatedArray };
        }),

        updateTemporalResArray: (layer, newTemporalRes) => set((state) => {
            const index = state.selectedLayers.indexOf(layer);
            if (index == -1) return {};

            const updatedArray = state.temporalResArray.map((temporalRes, i) =>
                i === index ? newTemporalRes : temporalRes
            );
            return { temporalResArray: updatedArray };
        }),

        deleteSelectedLayerByName: (layer) => set((state) => {
            const index = state.selectedLayers.indexOf(layer);
            if (index == -1) return {};

            const updatedSpatialArray = state.spatialResArray.filter((_, i) =>
                i !== index
            );
            const updatedTemporalArray = state.temporalResArray.filter((_, i) =>
                i !== index
            );
            const updatedSelectedLayers = state.selectedLayers.filter((_, i) => 
                i !== index
            )

            return {
                spatialResArray: updatedSpatialArray,
                temporalResArray: updatedTemporalArray,
                selectedLayers: updatedSelectedLayers
            };
        }),

        deleteSelectedLayerByIndex: (index) => set((state) => {
            const updatedSpatialArray = state.spatialResArray.filter((_, i) =>
                i !== index
            );
            const updatedTemporalArray = state.temporalResArray.filter((_, i) =>
                i !== index
            );
            const updatedSelectedLayers = state.selectedLayers.filter((_, i) => 
                i !== index
            )

            return {
                spatialResArray: updatedSpatialArray,
                temporalResArray: updatedTemporalArray,
                selectedLayers: updatedSelectedLayers
            };
        }),

        searchSelectedLayerIndex: (layer) => {
            const state = get();
            return state.selectedLayers.indexOf(layer);
        },

        clearSelectedLayers: () => set((state) => ({
            spatialResArray: [],
            temporalResArray: [],
            selectedLayers: []
        })),

        updateAllLayers: (newSpatialArray, newTemporalArray, newSelectedLayers) => set(() => ({
            spatialResArray: [...newSpatialArray],
            temporalResArray: [...newTemporalArray],
            selectedLayers: [...newSelectedLayers]
        })),

    })
);

export default useActiveLayersStore;